import React from 'react'

const WebViewSuccess = () => {
  return (
    <div></div>
  )
}

export default WebViewSuccess